// extracted by mini-css-extract-plugin
module.exports = {"label":"MenuItemToggle_label__3orG4ZXmLse66GNPfY1X94","container":"MenuItemToggle_container__3OLLi7k9_Qgw8YVRFCnJzs"};